"use client"

import { MemberListGridProps } from "@/types/types"
import { MemberListItem } from "./MemberListItem"

export const MemberListGrid = ({ members, className = "" }: MemberListGridProps) => {
  if (!members || members.length === 0) {
    return (
      <div className="text-center py-12 text-gray-500">
        <p>No members available.</p>
      </div>
    )
  }

  return (
    <div
      className={`grid grid-cols-2 md:grid-cols-3 gap-x-[1.875rem] px-[0.9375rem] sm:px-0 gap-y-[2.875rem] sm:gap-x-[0.25rem] sm:gap-y-[4.75rem] ${className}`}
    >
      {members.map((member, index) => (
        <MemberListItem key={index} member={member} />
      ))}
    </div>
  )
}
